import PropTypes from 'prop-types'
import React from 'react'
import { PageHeader, PageContent } from 'src/ui/index'
import { Preloader, AdditionalPreloader } from 'SRC/ui/Preloader'
import { getProfileLoading, getAddonsLoading, getAddonsSortedByGroup } from '../../../selectors'
import { fetchAddons } from '../../../actions'
import { connect } from 'react-redux'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { ProfileApi } from '../../../api'

export class Addons extends React.Component {
  constructor (props) {
    super(props)

    this.cookie = new CookiesHelper()
    this.state = {
      disabledActions: [],
      pendingAddons: [],
      addonsRequested: {}
    }
  }

  async componentDidMount () {
    const userId = this.cookie.get('userId')
    const token = this.cookie.get('token')
    if (userId && token) {
      await this.props.fetchAddons(userId, token)
      this.initState()
    }
  }

  initState = () => {
    const disabledActions = []
    const pendingAddons = []
    const addonsRequested = {}

    for (const addonGroupId in this.props.addonsSortedByGroup) {
      const addonGroup = this.props.addonsSortedByGroup[addonGroupId]
      const addons = addonGroup.elements
      for (const addon of addons) {
        addonsRequested[addon.id] = false
        if (addon.status) {
          if (!disabledActions.includes(addon.action.id)) {
            disabledActions.push(addon.action.id)
          }

          if (addon.status === 'pending') {
            if (!pendingAddons.includes(addon.id)) {
              pendingAddons.push(addon.id)
            }
          }
        }
      }
    }

    this.setState({ disabledActions, pendingAddons, addonsRequested })
  }

  getButtonTitle = (addon) => {
    if (addon.status && addon.status === 'active') return 'Aktivan'
    if (addon.status && addon.status === 'pending') return 'Na čekanju'
    if (this.state.pendingAddons.includes(addon.id)) return 'Na čekanju'
    return this.state.disabledActions.includes(addon.action.id) ? 'Nedostupno' : 'Aktiviraj'
  }

  getButtonClassName = (addon) => {
    if (addon.status) return addon.status
    if (this.state.pendingAddons.includes(addon.id)) return 'pending'
    return this.state.disabledActions.includes(addon.action.id) ? 'disabled' : ''
  }

  async requestAddon (addonId, actionId) {
    await this.setState(prevState => ({
      addonsRequested: {
        ...prevState.addonsRequested,
        [addonId]: true
      }
    }))
    const api = new ProfileApi()
    const userId = this.cookie.get('userId')
    const token = this.cookie.get('token')

    if (userId && token) {
      const result = await api.addAddonRequest(userId, token, addonId)
      if (result.status === 'ok') {
        const disabledActions = [...this.state.disabledActions]
        const pendingAddons = [...this.state.pendingAddons]
        if (!disabledActions.includes(actionId)) disabledActions.push(actionId)
        if (!pendingAddons.includes(addonId)) pendingAddons.push(addonId)
        await this.setState({ disabledActions, pendingAddons })
      }

      await this.setState(prevState => ({
        addonsRequested: {
          ...prevState.addonsRequested,
          [addonId]: false
        }
      }))
    }
  }

  renderAddonGroups = () => {
    const addons = this.props.addonsSortedByGroup
    return Object.keys(addons).sort((group1, group2) => addons[group1].weight - addons[group2].weight)
      .map(addonGroupId => <div className='dodaci-group' key={addonGroupId}>
        <h1 className='dodaci-group-heading'>{addons[addonGroupId].label}</h1>
        {addons[addonGroupId].elements.sort((addon1, addon2) => addon1.weightInGroup - addon2.weightInGroup)
          .map(addon => this.renderAddonItem(addon))}
      </div>)
  }

  renderAddonItem = addon => <div key={addon.id} className='tip-oglasa-item'>
    <p className='tip-oglasa-naziv'>{addon.name}</p>
    <p className='tip-oglasa-cena'>{addon.price}&euro;</p>
    <ul className='tip-oglasa-lista'>
      {addon.options && addon.options.map(option =>
        <li key={option}>- {option.split(' ').map(part => {
          return part !== '$PRO$' ? `${part} ` : <span className='pro' />
        })}</li>
      )}
    </ul>
    {!this.state.addonsRequested[addon.id] ? <a href='javascript:void(0)'
      className={this.getButtonClassName(addon)}
      onClick={addon.status === null && !this.state.disabledActions.includes(addon.action.id)
        ? () => this.requestAddon(addon.id, addon.action.id) : null}>
      {this.getButtonTitle(addon)}
    </a> : <AdditionalPreloader />}
  </div>

  render () {
    return <React.Fragment>
      <PageHeader key='header'>Dodaci</PageHeader>
      <PageContent key='content' additionalClass='active-addons'>
        <div className='registracija-content-heading'>
          <p className='heading'>Dodaci</p>
          <p>Aktivirajte dodatke za bolju prodaju i marketing! Cijene su bez PDV-a.</p>
        </div>
        {!this.props.isAddonsLoading
          ? this.renderAddonGroups()
          : <Preloader key='spinnerAddonsLoading' />}
        {this.props.isProfileLoading ? <Preloader key='spinnerProfileLoading' /> : null}
      </PageContent>
    </React.Fragment>
  }
}

const mapStateToProps = state => {
  return {
    isProfileLoading: getProfileLoading(state),
    addonsSortedByGroup: getAddonsSortedByGroup(state),
    isAddonsLoading: getAddonsLoading(state)
  }
}

Addons.propTypes = {
  isProfileLoading: PropTypes.bool.isRequired,
  addonsSortedByGroup: PropTypes.object.isRequired,
  isAddonsLoading: PropTypes.bool.isRequired,
  fetchAddons: PropTypes.func.isRequired
}

Addons.defaultProps = {
  isLoading: false,
  isAddonsLoading: false,
  addonsSortedByGroup: {}
}

export default connect(mapStateToProps, { fetchAddons })(Addons)
